import * as firebase from 'firebase'

//  Prod config
const prodConfig = {
  apiKey: "AIzaSyCfYvrPUtgibC_J3bUZNi-r8Lvc1bxOmsk",
  authDomain: "the-scorebook.firebaseapp.com",
  databaseURL: "https://the-scorebook.firebaseio.com",
  projectId: "the-scorebook",
  storageBucket: "the-scorebook.appspot.com",
  messagingSenderId: "480914799890"
};

//  Dev config
const devConfig = {
  apiKey: "AIzaSyDBzTcvpHimHb4p12URB7M_j5gl56kV6s0",
  authDomain: "the-scorebook-dev.firebaseapp.com",
  databaseURL: "https://the-scorebook-dev.firebaseio.com",
  projectId: "the-scorebook-dev",
  storageBucket: "the-scorebook-dev.appspot.com",
  messagingSenderId: "62875983501"
};

const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const auth = firebase.auth();

export {
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js